import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import { serializeCompany, serializeUser } from '../lib';
import { ICompanyIdStore, IPersonalStore } from '../types';

export const useCompanyIdStore = create<ICompanyIdStore>()(
  persist(
    (set) => ({
      companyId: null,
      setCompanyId: (companyId) => {
        set({ companyId });
      },
    }),
    {
      name: '@gatewayCompanyId',
    },
  ),
);

export const usePersonalStore = create<IPersonalStore>((set, _, store) => ({
  company: null,
  setCompanyInfo: (company) => {
    set({ company });
  },
  setCompany: (company) => {
    set({ company: serializeCompany(company) });
  },

  user: null,

  setUser: (user) => {
    set({ user: serializeUser(user) });
  },
  changeHasAddressUser: (isHasAddress) => {
    set(({ user }) => ({ user: { ...user, isHasAddress } }));
  },

  resetStore: () => {
    set(store.getInitialState());
  },
}));
